import React, { useState, useRef } from "react";
import "../../assets/css/newacitivity.css";
import Webcam from "react-webcam";
// import '@fortawesome/fontawesome-free/css/all.css'; // Import the Font Awesome CSS
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; // Im
import { ConstructorEventPost } from "../../Event/event";
import { StudentCloudFrontDistributionID, studentcameraimages, } from "../../api/aws-api";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { constrainPoint } from "@fullcalendar/core/internal";

export function Appone() {
    const getHtmlCode = useRef();
    const webcamRef = useRef(null);
    const [showWebcam, setShowWebcam] = useState(false);
    const navigate = useNavigate();
    const [htmlCode, setHtmlCode] = useState();
    const [imagename, setImageName] = useState();
    const [presignedurl, setPresignedurl] = useState("");
    const [showInput, setShowInput] = useState(false);
    const [inputFields, setInputFields] = useState([]);
    const [questionNumber, setQuestionNumber] = useState(0);
    const [Activitystarted, setActivitystarted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [selectedOption, setSelectedOption] = useState("");
    const [selectedColor, setSelectedColor] = useState("");
    const [selectedAttribute, setSelectedAttribute] = useState("");
    const [SelectedScreen, setSelectedScreen] = useState("");
    const [ClickedNext, setClickedNext] = useState(false);
    const [dragging, setDragging] = useState(true);
    const [divtochangeContent, setDivtochangeContent] = useState([]);
    const [ValueDropdown, setValueDropdown] = useState("");
    const [SelectedFontsize, setSelectedFontsize] = useState("");
    const [selectedpopup, setSelectedpopup] = useState(false);
    const [newnum,setNewnum] =useState(0);

    const handleAttributeChange = (event) => {
        console.log(event.target.value);
        if (Activitystarted == true) {
            setSelectedAttribute(event.target.value);
        }
    };
    const handleDragStart = (e) => {
        e.dataTransfer.setData("text/plain", e.target.id);
        setDragging(true);
    };

    const handleDragEnd = () => {
        setDragging(false);
    };
    const handleToggleWebcam = () => {
        setShowWebcam(!showWebcam);
        if (showWebcam) {
            // If webcam is hidden, call cameraimages with null or some default value
            cameraimages(null); // or cameraimages('defaultImageSrc')
        }
    };

    const capturePhoto = () => {
        const imageSrc = webcamRef.current.getScreenshot();
        console.log(`${imageSrc}`);
        setImageName(imageSrc);
        console.log(`retretredfdfdtre${imagename}`); // Set the image source to the state
        cameraimages(imageSrc);
    };
    
    const innum =()=>{
        setNewnum(newnum+1)
    }

    const handleDrop = (e) => {
        e.preventDefault();
        const droppedItemId = e.dataTransfer.getData("text/plain");
        const droppedItem = document.getElementById(droppedItemId);
        e.target.appendChild(droppedItem);

        setDragging(false);
    };
    const handleDragOver = (e) => {
        e.preventDefault();
    };
    const Dropdownselect = (event) => {
        var selectedvalue = event.target.value;
        setSelectedOption(selectedvalue);
        console.log(selectedvalue);
    };

    const handleclick = () => {
        setSelectedColor("background_color");
        setValueDropdown("green");
    };

    function handleHtmlCode() {
        const data = getHtmlCode.current.outerHTML;
        console.log("The extracted HTML code is----", data);
        setHtmlCode(data);
    }

    const popupvalue = () => {
        setSelectedpopup(!selectedpopup);
    };
    const cameraimages = async (imageSrc,innum) => {
        setLoading(true);

        // const files = e.target.files;
        // setProfileImage(files[0]);
        // console.log(files[0]);
        if (!imageSrc) {
            console.error("imageSrc is not provided");
            setLoading(false);
            return;
        }
        const responsedata = await ConstructorEventPost(studentcameraimages, {
            
            user_id: innum,
            imgType: 'image/jpeg',
            imgName: 'image',
            imageData: imageSrc,
        });

        if (responsedata !== null) {
            setPresignedurl(responsedata.body.response)
        }

        console.log(`the url is ${presignedurl}`)

        uploadImage(presignedurl, imagename)
            .then(() => {
                console.log("Image uploaded successfully:");
            })
            .catch((error) => {
                console.error("Error uploading image:", error);
            });
        console.log(presignedurl, "link"); // You can use this binary string in your code
        console.log("something");
    };


    const uploadImage = async (link, file) => {
        console.log(`link is ${link}`);
        console.log(`the file is ${file}`)
        const responsedata1 = await axios
            .put(link, file, {
                headers: {
                    "Content-Type": 'image/jpeg',
                },
            })
            .then(() => {
                // notify("Profile Image Updated");
                navigate("/codomo/home");
            });
        console.log(responsedata1, "response");
        setLoading(false);
    };

    const handleClick = () => {
        setShowInput(true);
    };

    const handleAddInput = () => {
        setInputFields([...inputFields, ""]);
    };

    const handleChange = (index, value) => {
        const newInputFields = [...inputFields];
        newInputFields[index] = value;
        setInputFields(newInputFields);
    };
    return (
        <div class="container">
            <div></div>
            <div className="grid grid-cols-12">
                <div className="lg:col-span-3 col-span-12 ">
                    <div className="Newbody">
                        <div className="Newheader">
                            <div
                                className="design-vew22"
                                ref={getHtmlCode}
                                onDrop={(e) => Activitystarted && handleDrop(e)}
                                onDragOver={(e) => Activitystarted && handleDragOver(e)}
                            >
                                <button
                                    // className="h-10 w-10 rounded bg-red-paste text-primary flex flex-col justify-center items-center text-2xl transition hover:bg-primary hover:text-white rounded-full"
                                    draggable="true"
                                    onDragStart={(e) => handleDragStart(e)}
                                    onClick={() => window.scrollTo({ top: 1000, behavior: "smooth" })}
                                >

                                </button>

                                {showWebcam && (
                                    <div >
                                        <Webcam
                                            audio={false}
                                            ref={webcamRef}
                                            screenshotFormat="image/jpeg"

                                        />
                                        <div className="flex justify-center mt-4">
                                            <button
                                                className="h-10 w-20 rounded text-primary flex flex-col justify-center items-center text-2xl transition hover:bg-primary hover:text-white rounded-full"
                                                onClick={capturePhoto}
                                            >
                                                SNAP
                                            </button>
                                        </div>
                                    </div>
                                )}
                                {imagename && (
                                    <div className="flex justify-center mt-4">
                                        <img src={imagename} alt="Captured" />
                                    </div>
                                )}

                                <button onClick={handleClick} >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="3em" height="2em" viewBox="0 0 24 24">
                                        <path fill="currentColor" d="M14.71 7.29a1 1 0 0 0-1.42 0L11 9.59l-2.29-2.3a1 1 0 1 0-1.42 1.42L9.59 11l-2.3 2.29a1 1 0 0 0 0 1.42a1 1 0 0 0 1.42 0l2.29-2.3l2.29 2.3a1 1 0 0 0 1.42 0a1 1 0 0 0 0-1.42L12.41 11l2.3-2.29a1 1 0 0 0 0-1.42M7 18a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3a1 1 0 0 0 0-2a5 5 0 0 0-5 5v8a5 5 0 0 0 5 5a1 1 0 0 0 0-2M18 7v6a1 1 0 0 0 2 0V7a5 5 0 0 0-5-5a1 1 0 0 0 0 2a3 3 0 0 1 3 3m3 11h-1v-1a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2"></path>
                                    </svg>
                                </button>
                                {showInput && (
                                    <div className="input-container">
                                        {inputFields.map((value, index) => (
                                            <input
                                                key={index}
                                                className="input-field"
                                                placeholder="Enter text"
                                                value={value}
                                                onChange={(e) => handleChange(index, e.target.value)}
                                            />
                                        ))}
                                        <button onClick={handleAddInput} className="add-button">
                                            Add Another Input Field
                                        </button>
                                    </div>
                                )}
                            </div>

                            {/* <div class="nav-controls2 d-flex justify-content-between align-items-center"> */}
                            <button
                                className="button-12 mt-2"
                                style={{ textAlign: "center" }}
                                onClick={() =>
                                    Activitystarted
                                        ? (setClickedNext(false), setActivitystarted(false))
                                        : setActivitystarted(true)
                                }
                            >
                                {Activitystarted ? "RESET" : "RUN"}
                            </button>
                            {/* </div> */}
                        </div>
                    </div>
                </div>
                <div class="lg:col-span-9 col-span-12 mt-5">
                    <i class="fa-duotone fa-up-down-left-right fa-spin fa-spin-reverse"></i>
                    <div className="NavbarApp">&emsp;Instructions</div>


                    <div className=" row ">
                        <div className="col-6 ">
                            <div class="box">
                                <div class="box-head">
                                    &emsp;Toolbox
                                    <a class="yellow-btn">
                                        <i class="fa-solid fa-minus"></i>
                                    </a>
                                    <iconify-icon
                                        icon="icon-park-twotone:right-c"
                                        width="20"
                                        class="iconify-icon-right"
                                    ></iconify-icon>
                                    <iconify-icon
                                        icon="ant-design:setting-outlined"
                                        width="20"
                                        class="iconify-icon-left"
                                    ></iconify-icon>
                                    { }
                                </div>
                            </div>
                            {/* <div className="design-vew22" style={{ paddingTop: "65px" }}> */}


                            <div class="box-content p-3">
                                <div class="controlhead">UI Controls</div>
                                <div>&emsp;</div>
                                <div onDragStart={handleDragStart} onDragEnd={handleDragEnd}>

                                    { }
                                    <div
                                        // class={selectedpopup ? null : "pin"}
                                        draggable="true"
                                        id="22"
                                    >
                                        <button
                                            className="h-10 w-10 rounded bg-red-paste text-primary flex flex-col justify-center items-center text-2xl transition hover:bg-primary hover:text-white rounded-full"
                                            onClick={handleToggleWebcam}
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="400" height="400" viewBox="0 0 128 128"><path fill="#90a4ae" d="M25.24 39.27H12.99c-1.63 0-2.95-1.32-2.95-2.95V29.1c0-1.63 1.32-2.95 2.95-2.95h12.25c1.63 0 2.95 1.32 2.95 2.95v7.22a2.962 2.962 0 0 1-2.95 2.95"></path><path fill="#94d1e0" d="M16.28 40.52h-4v-10.4c0-1.1.9-2 2-2s2 .9 2 2z"></path><path fill="#546e7a" d="M42.36 35.8h-5.51c-1.1 0-1.99-.89-1.99-1.99V28.3c0-1.1.53-1.58 1.99-1.99c1.46-.41 4.12-.46 5.51 0c1.14.38 1.99.89 1.99 1.99v5.51c0 1.1-.9 1.99-1.99 1.99"></path><path fill="#212121" d="M4 58.9h120v60.14H4z"></path><path fill="#b0bec5" d="M4 117.68v2.73c0 1.98 1.61 3.59 3.59 3.59h112.83c1.98 0 3.59-1.61 3.59-3.59v-2.73z"></path><path fill="#90a4ae" d="M43.34 40.55h-7.49c-2.44 0-4.42-1.98-4.42-4.42v-.65c0-2.44 1.98-4.42 4.42-4.42h7.49c2.44 0 4.42 1.98 4.42 4.42v.65a4.409 4.409 0 0 1-4.42 4.42"></path><path fill="#b0bec5" d="M121.73 34.16H8.05C5.81 34.16 4 35.97 4 38.21v21.72h120v-23.5c0-1.26-1.02-2.27-2.27-2.27"></path><path fill="#78909c" d="M112.49 55.24H94.34a1.92 1.92 0 0 1-1.92-1.92V40.67c0-1.06.86-1.92 1.92-1.92h18.15c1.06 0 1.92.86 1.92 1.92v12.66c0 1.05-.85 1.91-1.92 1.91"></path><path fill="#757575" d="M92.42 52.84V40.88c0-1.18.95-2.13 2.13-2.13h17.79c1 0 1.41.55 1.41.55L93.11 54.72s-.69-.42-.69-1.88"></path><path fill="#212121" d="M96.44 41.76h13.95v10.47H96.44z"></path><path fill="#616161" d="M10.58 115.87H5.7c-.94 0-1.7-.76-1.7-1.7V68.28c0-.94.76-1.7 1.7-1.7h4.88c.94 0 1.7.76 1.7 1.7v45.89c0 .94-.77 1.7-1.7 1.7m111.7 0h-4.88c-.94 0-1.7-.76-1.7-1.7V68.28c0-.94.76-1.7 1.7-1.7h4.88c.94 0 1.7.76 1.7 1.7v45.89c0 .94-.76 1.7-1.7 1.7"></path><path fill="#b9e4ea" d="M8.04 122.64c-1.1 0-2-.9-2-2v-2.44h4v2.44a2 2 0 0 1-2 2m113.82-64.12h-4v-20.4c0-1.1.9-2 2-2s2 .9 2 2zm-110.7 0h-4v-20.4c0-1.1.9-2 2-2s2 .9 2 2zm108.7 64.12c-1.1 0-2-.9-2-2v-2.44h4v2.44a2 2 0 0 1-2 2"></path><path fill="#fcebcd" d="M60.78 50.42c-.22 0-.41-.18-.41-.41V39.66c0-.22.18-.41.41-.41H84c.22 0 .41.18.41.41v10.35c0 .22-.18.41-.41.41z"></path><path fill="#78909c" d="M83.9 39.76v10.16H60.88V39.76zm.1-1.01H60.78c-.5 0-.91.41-.91.91v10.35c0 .5.41.91.91.91H84c.5 0 .91-.41.91-.91V39.66c0-.5-.4-.91-.91-.91"></path><path fill="#fff" d="M64.54 48.49c-.76 0-1.38-.62-1.38-1.38v-4.54c0-.76.62-1.38 1.38-1.38c.76 0 1.38.62 1.38 1.38v4.54c0 .76-.62 1.38-1.38 1.38m3.91 0c-.58 0-1.05-.47-1.05-1.05v-5.2a1.05 1.05 0 1 1 2.1 0v5.2c0 .58-.47 1.05-1.05 1.05m3.44 0a.77.77 0 0 1-.77-.77v-5.75a.77.77 0 0 1 1.54 0v5.75c0 .42-.34.77-.77.77"></path><circle cx={72.39} cy={88.31} r={32.79} fill="#616161"></circle><circle cx={72.39} cy={88.31} r={28.47} fill="#e0e0e0"></circle><circle cx={72.39} cy={88.31} r={20.33} fill="#2f7889"></circle><circle cx={72.39} cy={88.31} r={26.16}></circle><circle cx={72.39} cy={88.31} r={19.94} fill="#2f7889"></circle><path fill="#94d1e0" d="M67.67 71.58c-6.31 1.43-10.08 7.57-10.08 12.1c0 3.67 2.43 2.75 3.21 1.42c2.01-3.41 4.44-6.25 8.63-7.44c1.68-.48 3.64-1.53 3.44-3.49c-.28-2.79-3.05-3.08-5.2-2.59"></path><circle cx={72.39} cy={88.31} r={8.9} opacity={0.25}></circle></svg>
                                        </button>

                                    </div>
                                    <div
                                        onDragStart={(e) => Activitystarted && handleDragStart(e)}
                                        onDragEnd={(e) => Activitystarted && handleDragEnd(e)}
                                    ></div>
                                    <div
                                        // class={selectedpopup ? null : "pin"}
                                        draggable="true"
                                        id="26"
                                    >
                                        <button class="button" id="button67" draggable="true">
                                            <div class="icon">
                                                <span class="text-icon hide">Prompt</span>
                                                <svg
                                                    class="css-i6dzq1"
                                                    stroke-linejoin="round"
                                                    stroke-linecap="round"
                                                    fill="none"
                                                    stroke-width="2"
                                                    stroke="currentColor"
                                                    height="24"
                                                    width="24"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
                                                </svg>
                                            </div>
                                            <span class="title"> A I </span>
                                            <div class="padding-left hide">
                                                <div class="padding-left-line">
                                                    <span class="padding-left-text">Neural Networks</span>
                                                </div>
                                            </div>
                                            <div class="padding-right hide">
                                                <div class="padding-right-line">
                                                    <span class="padding-right-text">Computer Vision</span>
                                                </div>
                                            </div>
                                            <div class="background hide">
                                                <span class="background-text">Virtual Intelligence</span>
                                            </div>
                                            <div class="border hide">
                                                <span class="border-text">Bayesian Networks</span>
                                            </div>
                                        </button>
                                    </div>

                                    <div
                                        class={selectedpopup ? null : "pin"}
                                        draggable="true"
                                        id="4"
                                    >
                                        <div
                                            class="divtochange flex"
                                            style={{ whiteSpace: "nowrap" }}
                                        >
                                            DataBase{!divtochangeContent.includes("4") && "( URL )"}
                                            {divtochangeContent.includes("4") && (
                                                <div>
                                                    (
                                                    <select
                                                        class="dropdown"
                                                        onChange={(e) => (e.target.value)}

                                                    >
                                                        <option value="">Select</option>
                                                        <option value="">Name</option>
                                                        <option value="">Color</option>
                                                        <option value="">Emotion</option>
                                                    </select>
                                                    )
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div class=" draggable" draggable="true" id="8">
                                        <div class="box-content p-3">
                                            <div
                                                class={selectedpopup ? null : "plug-board work-space"}
                                                onDrop={handleDrop}
                                                onDragOver={handleDragOver}
                                            >

                                                <div class="plug-board-top">
                                                    OnEvent
                                                    <select
                                                        className="dropdown"
                                                        onChange={Dropdownselect}
                                                    >
                                                        <option value="">Select an option</option>
                                                        <option value="click">Click</option>
                                                        {/* <option nClick={capturePhoto}>selfie</option> */}

                                                        <div class="function">Function</div>
                                                    </select>
                                                </div>

                                                <div class="plug">
                                                    <div
                                                        class="plug-blue"
                                                        ondrop="drop(event)"
                                                        ondragover="allowDrop(event)"
                                                    ></div>
                                                </div>

                                                <div class="plug-board-bottom">
                                                    <div class="bottom-blue"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div style={{ height: 1000 }}></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-9">
                            <div class="box">
                                <div class="box-head">
                                    &emsp;Workspace
                                    <a
                                        class="btn "
                                        onClick={() => {
                                            popupvalue();
                                            handleHtmlCode();
                                        }}
                                    >
                                        <button> Show Code</button>
                                    </a>{" "}
                                    <a
                                        class="btn me-2"
                                        data-bs-toggle="modal"
                                        data-bs-target="#show-code-popup"
                                    >
                                        <button> Version History</button>
                                    </a>
                                    {selectedpopup && (
                                        <div className="modal">
                                            <div className="overlay">
                                                <div className="modal-content">
                                                    {htmlCode ? htmlCode : null}
                                                    <button
                                                        className="btn"
                                                        style={{ marginTop: "30px" }}
                                                        onClick={popupvalue}
                                                    >
                                                        close
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div
                                    class="box-content p-3"
                                    onDrop={handleDrop}
                                    onDragOver={handleDragOver}
                                >
                                    <div class="plug-board work-space" id="drop-zone"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Appone;
